(function(){

    angular.module('tmx-app').controller('bulkReassignmentCtrl', ['$scope', '$mdDialog','BulkReassignmentService',
        'resolvedData','menu','tmxResource','LoanApplicationService','UsersService','ToastService','tmxUtility', 
    
        function BulkReassignmentCtrl($scope, $mdDialog, BulkReassignmentService, resolvedData,menu,tmxResource,LoanApplicationService,UsersService,ToastService,tmxUtility){
  
            var bulkReassignmentVM=this;
            bulkReassignmentVM.menu = menu;
            bulkReassignmentVM.getWorkflowStatesByProduct = getWorkflowStatesByProduct;
            bulkReassignmentVM.getUsersByLocation = getUsersByLocation;
            bulkReassignmentVM.formatDate=tmxUtility.formatDateForCompany; 
    
            bulkReassignmentVM.LoanApplicationStartDate = new Date();
            bulkReassignmentVM.assignPermission= tmxUtility.checkPermission("Private.Administration.BulkReassignment","Assign");

            function getWorkflowStatesByProduct(ProductId) {
                if(ProductId) {
                    tmxResource("LoanApplication").getByAction('WorkflowStates/'+ProductId,true).then(function(response) {
                        bulkReassignmentVM.taskLkp = response.data;
                        bulkReassignmentVM.taskLkp.forEach(function(item) {
                            item.LookupId = item.Name;
                            item.VisibleValue = item.VisibleName;        
                        });

                    })
                }
                else {
                    bulkReassignmentVM.taskId = null;
                    bulkReassignmentVM.taskLkp = [];
                }
        
            }

            function getUsersByLocation(branchId){
                bulkReassignmentVM.userId = null;        
       
                UsersService.getUserByBranchId(branchId).then(function(response) {
                    bulkReassignmentVM.usersLkp = response.data;
                    bulkReassignmentVM.usersLkp.forEach(function(item) {
                        item.LookupId = item.UserId;
                        item.HiddenValue = item.UserId;
                        item.VisibleValue = item.UserName;
                    })
            
                    if(!branchId) {
                        bulkReassignmentVM.usersLkp = [];
                        bulkReassignmentVM.userId = null;            
                    }
                });
            }

    
            resolvedData.branches.data.forEach(function(item) {
                item.HiddenValue = item.CompanyBranchId;
                item.VisibleValue = item.BranchName;
            })

            bulkReassignmentVM.BranchesLkp=resolvedData.branches.data;

            bulkReassignmentVM.LoanProductsLkp=resolvedData.loanProducts.data;
            bulkReassignmentVM.LoanProductsLkp.forEach(function(item) {
                item.LookupId = item.ProductId;
                item.VisibleValue = item.ProductName;        
            });

            bulkReassignmentVM.searchLoanApplications = searchLoanApplications;

            function searchLoanApplications(form) {
                if(form.$valid) {
                    bulkReassignmentVM.container.loanApplicationGrid.dataSource.read();
                }
        
            }


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
            bulkReassignmentVM.BulkReassignmentService = BulkReassignmentService;
  

  //**********functions****************
            bulkReassignmentVM.reload=function(){
                bulkReassignmentVM.container.deviceGrid.dataSource.read();
            }

            bulkReassignmentVM.applicationReassign = applicationReassign;
            bulkReassignmentVM.applicationChecked = applicationChecked;        
            bulkReassignmentVM.allApplicationChecked = allApplicationChecked;        

            bulkReassignmentVM.selectedApplicationList = [];

            function allApplicationChecked(check) {
                var data = $('#grid').data('kendoGrid').dataSource.data();
                if(!check) {
                    bulkReassignmentVM.selectedApplicationList = [];
                }
                data.forEach(function (item) { 
                    if(!item.Selected) {
                        bulkReassignmentVM.selectedApplicationList.push(item.ProcessInstanceID);
                        bulkReassignmentVM.selectedApplicationList = [];
                    }

                    item.Selected = check;               
                })

            }

            function applicationChecked(dataItem) {
                if(dataItem.Selected) {

        // bulkReassignmentVM.selectedApplicationList.push(dataItem.ProcessInstanceID);

                    bulkReassignmentVM.selectedApplicationList.push(
                        {
                            InboxUserId:dataItem.InboxUserID,
                            ProcessId : dataItem.ProcessInstanceID,
                            TargetUserId:null
                        }
                    );
                }
                else {
                    var indexOfObj = bulkReassignmentVM.selectedApplicationList.findIndex(x => x.ProcessId ==dataItem.ProcessInstanceID);
                    bulkReassignmentVM.selectedApplicationList.splice(indexOfObj,1);            
                }
      
            }
  
            function applicationReassign(ev) {          
                if(bulkReassignmentVM.selectedApplicationList.length < 1) {
                    ToastService.showCustomToast("error","Please Select Application");
                    return;
                }
                var data = $('#grid').data('kendoGrid').dataSource.data();
        //   var roleId = data[0].InboxUserRoleID;
                $mdDialog.show({
                    controller:['$scope', 'UsersService' ,'data','branchId', ReassignDialogController] ,
                    locals:{data: data[0],branchId:bulkReassignmentVM.branchId},
                    templateUrl: 'app/private/inbox/reassign-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:false,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function(targetUserId) {
                        if(targetUserId) {
                            angular.forEach(bulkReassignmentVM.selectedApplicationList,function(item) {
                                item.TargetUserId = targetUserId;
                            });

                            LoanApplicationService.reassignApplication(bulkReassignmentVM.selectedApplicationList).then(function() {
                                bulkReassignmentVM.selectedApplicationList = [];
                                $('#grid').data('kendoGrid').dataSource.read();
                            });                        
                        }   
                    }, function() {
          
                    });
            }

            function ReassignDialogController($scope,UsersService,data,branchId) {
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
    
                UsersService.getUsersByLocation(branchId,data.InboxUserRoleID).then(function(response) {
                    var listOfUsers = response.data;
                    $scope.UserList = [];
                    listOfUsers.forEach(function(item) {
                        // if(item.UserID != data.InboxUserID &&  new Date(item.EffectiveEndDate+'Z') > new Date())
                        if(item.UserID != data.InboxUserID &&  new Date(item.EffectiveEndDate) > new Date()) {
                            item.HiddenValue = item.UserID;
                            item.VisibleValue = item.UserName;
                            $scope.UserList.push(item);
                        }                        
                    })
                    
                });
              
                $scope.done = function(userId) {
        
                    $mdDialog.hide(userId);
                };
            }


//*******************KENDO*********************//  
            bulkReassignmentVM.gridColumns = BulkReassignmentService.columns;
            bulkReassignmentVM.createFilters = createFilters;
            function createFilters(filterArray) {
                if(bulkReassignmentVM.productId) {
                    filterArray.push(
                        {
                            field:"ProductId",
                            operator:"eq",
                            value:bulkReassignmentVM.productId,
                            logic: "and"
                        }
                    );
                }
    
                if(bulkReassignmentVM.LoanApplicationStartDate) {
                    filterArray.push(
                        {
                            field:"ApplicationDate",
                            operator:"gte",
                            value:moment(new Date(bulkReassignmentVM.LoanApplicationStartDate)).startOf('day').toISOString(),
                            logic: "and"
                        }
                    );
                }
                if(bulkReassignmentVM.LoanApplicationEndDate) {
                    filterArray.push(
                        {
                            field:"ApplicationDate",
                            operator:"lte",
                            value:moment(new Date(bulkReassignmentVM.LoanApplicationEndDate)).endOf('day').toISOString(),
                            logic: "and"
                        }
                    );
                }    
                if(bulkReassignmentVM.taskId) {
                    filterArray.push(
                        {
                            field:"CurrentState",
                            operator:"eq",
                            value:bulkReassignmentVM.taskId,
                            logic: "and"
                        }
                    );
                }

                 
                if(bulkReassignmentVM.userId) {
                    filterArray.push(
                        {
                            field:"InboxUserID",
                            operator:"eq",
                            value:bulkReassignmentVM.userId,
                            logic: "and"
                        }
                    );
                }    
                
                else if(bulkReassignmentVM.branchId) {
                    filterArray.push(
                        {
                            field:"CompanyBranchId",
                            operator:"eq",
                            value:bulkReassignmentVM.branchId,
                            logic: "and"
                        }
                    );
                }

                // filterArray.push(
                //     {
                //         field:"InboxUserID",
                //         operator:"lt",
                //         value:null,
                //         logic: "and"
                //     }
                // );

                return filterArray;
            }        
            
            bulkReassignmentVM.mainGridOptions = {
                dataSource: {
            
                    transport: {
                        read: function(o){
                            if(bulkReassignmentVM.dialogForm.$valid) {
                                bulkReassignmentVM.o = angular.copy(o);  
                                o.data.filter = [];
                                o.data.filter.logic = 'and';
                                o.data.filter.filters = [];
                                var filterArray = o.data.filter.filters;
                                o.data.filter.filters = [];
                                o.data.filter.filters = createFilters(filterArray);

                                if(filterArray[0].field == 'ProductId') {                    
                                    BulkReassignmentService.getByParams(o,true).then(function(response){    
                                        bulkReassignmentVM.showBulkAssignment  = response.data.length > 0?true:false;                       
                        
                                        angular.forEach(response.data,function(result) {
                                            var index =  bulkReassignmentVM.selectedApplicationList.findIndex(x => x.ProcessId == result.ProcessInstanceID);                            
                                            if(index > -1) {
                                                result.Selected = true;
                                            }
                                            else {
                                                result.Selected = false;
                                            }                        
                                        })
                                        parseResppnse(response.data);
                                        o.success(response)
    
                                    });                      
                                }
                                else {
                                    var response = {
                                        AggregateResults:null,
                                        Data:[],
                                        Errors:null,
                                        Total:0,
                                        data:[],
                                    }
                                    bulkReassignmentVM.showBulkAssignment  = response.data.length > 0?true:false;
                                    parseResppnse(response.data);
                                    o.success(response)
                                }

                            }
                            else{
                                response = {
                                    AggregateResults:null,
                                    Data:[],
                                    Errors:null,
                                    Total:0,
                                    data:[],
                                }
                                bulkReassignmentVM.showBulkAssignment  = response.data.length > 0?true:false;
                                parseResppnse(response.data);
                                o.success(response)
                            }
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort:  [{field: "ApplicationID", dir: "desc"}]
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 4
                },

                pdf: {
                    allPages: true,
                    fileName: "BulkReassignment.pdf"
                },
                excel: {
         /* allPages: true,*/
                    fileName: "BulkReassignment.xlsx"
                },
                sortable: true,
                scrollable: false,
                columns: BulkReassignmentService.columns
            };
   

            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.ApplicationDate = bulkReassignmentVM.formatDate(dataItem.ApplicationDate);
                    
                });
            }
        }]); 
})();